export default "__VITE_ASSET__BwF8rMr0__"